import { pageView, track } from '@dafiti/analytics-sdk';
import isMobile from '../utils/helper/device';
import { useConfig } from './ConfigProvider';
import { GoogleTagManagerProps } from './types';

declare global {
  interface Window {
    dataLayer: GoogleTagManagerProps[];
  }
}

export enum GoogleAnalyticsConstants {
  PAGE_VIEW = 'page_view_ga4',
  LOGIN = 'login_ga4',
  SIGN_UP = 'sign_up_ga4',
  ERROR_EVENT = 'error_event_ga4',
  AB_TEST_EVENT = 'ab_test_event_ga4',
  AB_TEST_LOGIN_FRONT = 'new_login_front_flag',
  CUSTOMER_PHONE_ENABLED = 'customer_phone_flag',
  CUSTOMER_PHONE_REQUIRED = 'customer_phone_required_flag',
}

export const pushToDataLayer = (
  type: string,
  method: string,
  userId: string,
  buyer: string,
) => {
  if (window && window.dataLayer) {
    let event = '';
    if (type === 'login') {
      event = 'login_ga4';
    } else {
      event = 'sign_up_ga4';
    }
    track(event, {
      method: method,
      user_id: userId,
      buyer_type: buyer,
    });
  }
};

export const pushPageViewDataLayer = (page: string, event: string) => {
  // Verifica se o dataLayer está disponível
  if (window && window.dataLayer) {
    pageView(
      {
        path: window.location.pathname,
        location: window.location.href,
        title: page,
      },
      {
        buyerType: event,
      },
    );
  } else {
    console.log('dataLayer is not defined');
  }
};

export const eventABTest = (name: string, variant: string) => {
  if (window && window.dataLayer) {
    const device = isMobile() ? 'msite' : 'desktop';
    window.dataLayer = window.dataLayer ? window.dataLayer : [];
    track('ab_test_event_ga4', {
      ab_test_name: name,
      ab_test_variant: name + '_' + device + '_' + variant,
    });
  }
};

export const eventABActivationTest = (
  event: string,
  name: string,
  variant: string,
) => {
  if (window && window.dataLayer) {
    window.dataLayer = window.dataLayer ? window.dataLayer : [];
    track(event, {
      ab_test_name: name,
      ab_test_variant: variant,
    });
  }
};

export const eventABLoginSuccess = (
  event: string,
  name: string,
  variant: string,
  method: string,
) => {
  if (window && window.dataLayer) {
    window.dataLayer = window.dataLayer ? window.dataLayer : [];
    track(event, {
      ab_test_name: name,
      ab_test_variant: variant,
      method: method,
    });
  }
};

export const sendErrorToGa = (
  trigger: string,
  errorType: string,
  errorName: string,
) => {
  if (window && window.dataLayer) {
    track('error_event_ga4', {
      error_trigger_time: trigger,
      error_type: errorType,
      error_name: errorName,
    });
  }
};

export default () => {
  const config = useConfig();
  const gtmId = config ? config.REACT_APP_GOOGLE_TAG_MANAGER : '';

  const script = document.createElement('script');
  script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `;
  document.head.appendChild(script);
};
